var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":'/news/' + _vm.item.slug.en}},[_c('img',{attrs:{"src":'/storage/' + _vm.item.image,"alt":_vm.item.title.en}}),_vm._v(" "),_c('span',{staticClass:"title-4 color-text-white"},[_vm._v(_vm._s(_vm.item.title.en))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }